import React, {useState} from 'react';
import {PiTelegramLogoLight} from "react-icons/pi";
import {toast} from "react-toastify";
import {sendMessage} from "../actions/message";
import {useDispatch} from "react-redux";

const ContactInfo = () => {
    const dispatch = useDispatch();
    const [name, setName] = useState('');
    const [phone, setPhone] = useState('');
    const [email, setEmail] = useState('');
    const [textMessage, setTextMessage] = useState('');
    const sendMessageHandle = () => {
        if (name !== '' && phone !== '' && textMessage !== ''){
            const message = {};
            message.name = name;
            message.phone = phone;
            message.email = email;
            message.message = textMessage;
            dispatch(sendMessage(message));
            setName('');
            setPhone('');
            setEmail('');
            setTextMessage('');
        } else {
            toast.warning('Поля "Имя", "Телефон" и "Сообщение" должны быть заполнены!', {
                position: 'bottom-right',
                autoClose: true
            })
        }
    }
    const handleChangeName = (event) => {
        setName(event.target.value);
    };
    const handleChangePhone = (event) => {
        setPhone(event.target.value);
    };
    const handleChangeEmail = (event) => {
        setEmail(event.target.value);
    };

    const handleChangeMessage = (event) => {
        setTextMessage(event.target.value);
    };
    return (
        <div className="contact_area mt-50">
            <div className="container">
                <div className="row">
                    <div className="col-lg-6 col-md-12">
                        <div className="contact_message content" itemProp="address" itemScope itemType="https://schema.org/PostalAddress">
                            <h3>Контакты</h3>
                            <p>Север лес</p>
                            <ul>
                                <li itemProp="streetAddress"><i className="fa fa-fax"></i> Адрес : Московская область, Павлово-Посадский городской округ, индустриальный парк Улитино, 4
                                </li>
                                <li itemProp="telephone"><i className="fa fa-phone"></i>+7 (916) 737-55-95</li>
                                <li itemProp="telephone"><i className="fa fa-phone"></i>+7 (495) 222-32-95</li>
                                <li><PiTelegramLogoLight size={18}/><a className="link-footer" href="https://t.me/holc_city" target="_blank"> holc_city</a></li>
                                <li itemProp="email"><i className="fa fa-envelope-o"></i><a className="link-footer" href="mailto:89852223295@mail.ru">89852223295@mail.ru</a></li>
                            </ul>
                        </div>
                    </div>
                    <div className="col-lg-6 col-md-12">
                        <div className="contact_message form">
                            <h3>Напишите нам</h3>
                                <p>
                                    <label> Ваше имя</label>
                                    <input name="name" placeholder="Имя *" type="text" value={name} onChange={handleChangeName}/>
                                </p>
                                <p>
                                    <label> Ваш Email</label>
                                    <input name="email" placeholder="Email" type="email" value={email} onChange={handleChangeEmail}/>
                                </p>
                                <p>
                                    <label> Номер телефона</label>
                                    <input name="subject" placeholder="Телефон *" type="text" value={phone} onChange={handleChangePhone}/>
                                </p>
                                <div className="contact_textarea">
                                    <label> Ваше сообщение</label>
                                    <textarea placeholder="Сообщение *" name="message"
                                              className="form-control2" value={textMessage} onChange={handleChangeMessage}></textarea>
                                </div>
                                <button onClick={() => {
                                    sendMessageHandle()
                                }}> Отправить</button>
                                <p className="form-messege"></p>

                        </div>
                    </div>
                </div>
            </div>
        </div>
);
};

export default ContactInfo;